<img class="ds-mr-10" [src]="'./assets/Square Chat (Blue-Gray).svg' | resolveAsset" alt="" />
<span>
	Have questions or feedback?
	<a style="color: #7083a0 !important" href="" target="_blank">Chat with us</a>
</span>
